<div class="lp-text-canvas-component">
  <app-style-sheet-sprite
    [sprite]="_stylesService.LABEL_PANEL()?.container"
    [text]="_stylesService.LABEL_PANEL()?.text"
    style="display: block; place-self: center"
  >
    <lp-text [text]="comp().text" [style]="textStyle()" />
  </app-style-sheet-sprite>
</div>
